import { Grid, GridColumn as Column, GridToolbar  } from "@progress/kendo-react-grid";
import React, { useState } from 'react'; 
import config from '../appconfig/config.json';
import personDtlsData from '../data/persondetailsdata.json';

const ADJUST_PADDING = 1;
const COLUMN_MIN = 4;

const columns = [
    {
      field: "forMonth",
      title: personDtlsData.cpfHistoryColumns[0],
      minWidth: 100,
    },
    {
      field: "paidOn",
      title: personDtlsData.cpfHistoryColumns[1],
      minWidth: 180,
    },
    {
      field: "amount",
      title: personDtlsData.cpfHistoryColumns[2],
      minWidth: 100,
    },
    {
      field: "employerContribution",
      title: personDtlsData.cpfHistoryColumns[3],
      minWidth: 220,
    }
  ];

const PersonCPFHistory = (props) => {
    const {minData, maxData } = props;
    const [showMore,setShowMore] = useState(false);

    const handleOnClick = () => {
        setShowMore(!showMore);
    }

    const minGridWidth = React.useRef(0);
    const grid = React.useRef(null);
 
    const [applyMinWidth, setApplyMinWidth] = React.useState(false);
    const [gridCurrent, setGridCurrent] = React.useState(0);

    React.useEffect(() => {
        grid.current = document.querySelector(".k-grid");
        window.addEventListener("resize", handleResize);
        columns.map((item) =>
          item.minWidth !== undefined
            ? (minGridWidth.current += item.minWidth)
            : minGridWidth.current
        );
        setGridCurrent(grid.current.offsetWidth);
        setApplyMinWidth(grid.current.offsetWidth < minGridWidth.current);
    }, []);

    const handleResize = () => {
        if (grid.current.offsetWidth < minGridWidth && !applyMinWidth) {
          setApplyMinWidth(true);
        } else if (grid.current.offsetWidth > minGridWidth) {
          setGridCurrent(grid.current.offsetWidth);
          setApplyMinWidth(false);
        }
    };

    const setWidth = (minWidth) => {
        if(minWidth === undefined) {
            minWidth = 0;
        }

        let width = applyMinWidth
          ? minWidth
          : minWidth + (gridCurrent - minGridWidth.current) / columns.length;
        if(width < COLUMN_MIN) {
            width =width;
        } else {
            (width -= ADJUST_PADDING);
        }
        return width;
    };
 
    return(
        <div style={{width:'100%'}} className="inputPair">
            <Grid data={showMore? maxData:minData} resizable={true} scrollable={'scrollable'}>
                {/* <Column title={personDtlsData.cpfHistoryColumns[0]} field="forMonth"  /> 
                <Column title={personDtlsData.cpfHistoryColumns[1]} field="paidOn"   /> 
                <Column title={personDtlsData.cpfHistoryColumns[2]} field="amount"  />
                <Column title={personDtlsData.cpfHistoryColumns[3]} field="employerContribution" /> */}
                {columns.map((column, index) => {
                        return (
                        <Column
                            field={column.field}
                            title={column.title}
                            key={index}
                            width={setWidth(column.minWidth)}
                        />
                        );
                    })}
                <GridToolbar>
                {(minData && minData.length > 1)&&
                        <span className="k-space-left" style={{fontSize: "14px",position:'absolute',right:'0'}} 
                            onClick={handleOnClick}>
                            {!showMore?
                            <>Click to see more<span className="k-icon k-i-arrow-chevron-down" /></> :
                            <>Click to see less<span className="k-icon k-i-arrow-chevron-up" /></>
                            }
                        </span>
                }
                </GridToolbar>
            </Grid>
        </div>
    )
}

export default PersonCPFHistory;